import * as React from "react";
import { FaExchangeAlt } from "react-icons/fa";
import styled from "styled-components";

const StyledExchange = styled(FaExchangeAlt)`
  margin-right: 0.5em;
`;

export const ContentMigrationButton = styled.button(
  ({ theme }) => `
  background: ${theme.colors.highlightLightGrey};
  display: block;
  font-size: ${theme.primaryTheme.primaryFontSize};
  height: 5rem;
  margin: 0 auto;
  width: 50%;
  &:hover {
    background: ${theme.colors.lightgrey};
  }
  border-radius: 0.5em;
  cursor: pointer;
  color: ${theme.colors.darkblue};
`
);

const VerticalAlignContainer = styled.div`
  vertical-align: middle;
`;

interface IContentMigrationProps {
  migrateToHtml: () => void;
}

const ContentMigration: React.SFC<IContentMigrationProps> = ({ migrateToHtml }) => (
  <>
    <h2>
      <b>
        Dear user, in order to continue applying changes to course content, you need to first migrate them from markdown
        to html
      </b>
    </h2>
    <ContentMigrationButton title="Migrate content" onClick={migrateToHtml}>
      <VerticalAlignContainer>
        <StyledExchange />
        Backup and Migrate to HTML
      </VerticalAlignContainer>
    </ContentMigrationButton>
  </>
);

export default ContentMigration;
